import React from "react";

import PaymentResult from "./PaymentResult";

const Fail = (props) => <PaymentResult outcome="fail" location={props.location} />;

export default Fail;
